import { observer } from "mobx-react-lite";
import { ANONYMOUS } from "../models/constants";
import { rootStore } from "../StApp";

interface NavProps{
    icon: string
    label: string
    index: number
    callBack: (index: number)=>void
}

export const NavItem = observer((props:NavProps) => {

    function getColor(){
        if(rootStore.uiStore.bottomNavIndex == props.index)
         return 'purple'
        else if(rootStore.mainStore.userName == ANONYMOUS){
            return 'gray'
        }
        else
         return undefined
         
    }

    return (
        <div className='flex-column nav-bar-item center-align' onClick={()=>props.callBack(props.index)} >
            <span className="material-icons-outlined" style={{color: getColor()}} >
                {props.icon}
            </span>
            <p style={{color: getColor()}} >{props.label}</p>
        </div>
    )
})